// Selection keys (05d, main.js's keydown — Ben's #173 + #178). Desktop only, as in main.js.
//   - Cmd/Ctrl+A selects every module, so "change the player everywhere" is select-all,
//     then pick a player in any one.
//   - Delete / Backspace closes every selected module as ONE undo step.
// Neither fires while you're typing: a text field keeps its own select-all and Backspace.

import { useEffect } from "react";
import { canvasApi, isCanvasInstalled } from "./shell-actions.js";
import { selectAll } from "./selection.js";

export function useSelectionKeys(): void {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent): void {
      if (!isCanvasInstalled()) return;
      const active = document.activeElement as HTMLElement | null;
      const isEditableFocus =
        !!active && (active.tagName === "TEXTAREA" || active.tagName === "INPUT" || active.isContentEditable);

      if (!isEditableFocus && (e.ctrlKey || e.metaKey) && e.key === "a") {
        if (window.innerWidth <= 768) return;
        e.preventDefault(); // otherwise the browser selects all the page's text
        selectAll();
      }

      if (e.key === "Delete" || e.key === "Backspace") {
        if (window.innerWidth <= 768) return;
        // A focused <select> counts here too (main.js), unlike for Cmd/Ctrl+A.
        if (isEditableFocus || active?.tagName === "SELECT") return;
        // Backspace otherwise navigates the browser back — only when there's a selection.
        if (canvasApi().deleteSelected()) e.preventDefault();
      }
    }

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);
}
